<template>
  <div class="videos">
    <div class="featured-videos" v-if="featuredVideo">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="row">
          <div id="single-video" class="col-lg-7 col-md-12">
            <article class="post-video">
              <div class="video-info dropshd">
                <div class="video-embed-box">
                  <div v-html="featuredVideo.iframeCode"></div>
                </div>
                <router-link :to="{ name: 'VideoPage', params: { id: featuredVideo.id, slug: featuredVideo.slug } }">
                  <h2 class="title main-head-title">{{ featuredVideo.name }}</h2>
                </router-link>
                <div class="metabox">
                  <span class="meta-i"><i class="fa fa-clock-o"></i>{{ featuredVideo.date }}</span>
                </div>
              </div>
            </article>
          </div>
          <!-- SIDE VIDEOS -->
          <div class="col-lg-5 col-md-12" v-if="featuredVideos.length > 0">
            <div class="row">
              <article class="col-lg-6 col-md-6 col-sm-6" v-for="video in featuredVideos">
                <single-video :video="video"></single-video>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="last-videos">
      <h2 class="icon"><i class="fa fa-television" aria-hidden="true"></i>Dernières vidéos</h2>
      <vimeo-videos
        :per_page="21"
        @onSuccess="setVideos"
      ></vimeo-videos>
      <div class="row auto-clear">
        <article class="col-lg-3 col-md-6 col-sm-4" v-for="video in lastVideos">
          <single-video :video="video"></single-video>
        </article>
      </div>
      <div class="clearfix spacer"></div>
      <div class="text-right" v-if="lastVideos.length > 0">
        <router-link :to="{ name: 'AllVideos', params: { type: 'last', page: 1, title: 'toutes-les-videos' } }" class="btn btn-primary btn-lg">Voir plus de vidéos</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { VimeoVideos } from 'itrnews-vuejs-api';
  import SingleVideo from './elements/Singlevideo';

  export default {
    name: 'LastVideos',
    components: { VimeoVideos, SingleVideo },
    methods: {
      setVideos({ data: videos }) {
        this.featuredVideo = videos.concat().splice(0, 1)[0];
        this.featuredVideos = videos.concat().splice(1, 4);
        this.lastVideos = videos.concat().splice(5, videos.length);
      },
    },
    data() {
      return {
        featuredVideo: null,
        featuredVideos: [],
        lastVideos: [],
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LastVideos.vue